import api from '@/api';
import { API_BASE_URL } from '..';
import {
  LinkUserMatrixRequest,
  SentEmailCodeValidateRequest,
  UnlinkUserMatrixRequest,
} from './User.types';

const baseUrl = `${API_BASE_URL}`;

export async function sentEmailValidateCodeUser(
  obj: SentEmailCodeValidateRequest,
) {
  const result = (await api.post(`${baseUrl}/codes`, obj, null)) as unknown;

  return result;
}

export async function linkUserMatrix(obj: LinkUserMatrixRequest) {
  const result = (await api.post(
    `${baseUrl}/users/link-matrix`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function unlinkUserMatrix(obj: UnlinkUserMatrixRequest) {
  const result = (await api.post(
    `${baseUrl}/users/unlink-matrix`,
    obj,
    null,
  )) as unknown;

  return result;
}
